import React from "react";
import ApplicationError from "@insightfulscience/smart-react/ApplicationError";
import WithErrorHandling from "@insightfulscience/smart-react/hocs/WithErrorHandling";
import AppError from "./AppError";
import { notifySentry } from "../../sentry";

export default WithErrorHandling({
	serialize: (error) => ApplicationError.of(error ?? {}).toSerializable(),
	render: (error) => <AppError error={error} />,
	onError: notifySentry,
});
